import { TokenUsageViewDetails } from '../../../../../libs/models/TokenUsage';

interface ITokenUsageBar {
    details: TokenUsageViewDetails;
    totalUsage: number;
}

export const TokenUsageBar: React.FC<ITokenUsageBar> = ({ details, totalUsage }) => {
    const percentage = details.usageCount / totalUsage;
    let barWidth = percentage * 500;

    return (
        <div
            key={details.legendLabel}
            style={{
                // backgroundColor: details.color,
                width: `${barWidth}px`,
            }}
            className={`h-3 ${details.color}`}
            title={`${details.legendLabel} (${details.usageCount})`}
        />
    );
    {/* <Popover
            openOnHover
            mouseLeaveDelay={0}
            positioning={{
                position: 'above',
            }}
            withArrow
            appearance="inverted"
        >
            <PopoverTrigger>
                <div
                    key={details.legendLabel}
                    className={`bg-primary h-2 w-${barWidth}`}
                />
            </PopoverTrigger>
            <PopoverSurface>{`${details.legendLabel} (${details.usageCount})`}</PopoverSurface>
        </Popover> */}

};
